import * as React from 'react'

import { Box, Title } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useFeatures } from 'modules/core/hooks/useFeatures'
import { acceptedContentTypes } from 'modules/core/lib/fileFormats'
import i18n from 'modules/core/lib/i18n'

import { FileListSkeleton } from 'modules/ats/components/FileListSkeleton'
import { useCandidateFiles } from 'modules/ats/hooks/candidateFiles'
import DropzoneBox from 'modules/documents/components/Documents/DropzoneBox'

import { OtherFilesList } from './OtherFilesList'

interface Props {
  candidateId: string
}

export const OtherFiles = ({ candidateId }: Props) => {
  const { has_ats_upload_files: canUploadFiles } = useFeatures(['ats_upload_files'])
  const { loadingFiles, candidateFiles, bulkCreateCandidateFiles } = useCandidateFiles({
    atsCandidateId: candidateId,
  })
  const { access } = useCurrentSession()
  const onUploadFile = async (selectedFiles: File[]) => {
    await bulkCreateCandidateFiles({
      atsCandidateId: candidateId,
      resourceId: candidateId,
      resourceType: 'candidate',
      authorId: access.id,
      authorType: 'access',
      files: selectedFiles.map((file) => {
        return { attachment: file }
      }),
    })
  }

  return (
    <Box gap="s32">
      <Title
        variant="400"
        illustration="documents"
        title={i18n.t('ats.candidate_details.files.other_files.title')}
        description={i18n.t('ats.candidate_details.files.other_files.description')}
      />

      {canUploadFiles && (
        <DropzoneBox
          onDrop={onUploadFile}
          message={i18n.t('documents.drop_here')}
          accept={acceptedContentTypes()}
        />
      )}

      {loadingFiles ? <FileListSkeleton /> : <OtherFilesList files={candidateFiles} />}
    </Box>
  )
}
